module.exports = __webpack_public_path__ + "static/media/lock.288f52b8.svg";